'use strict';

/** Cookie有効期限 (秒) */
const COOKIE_EXPIRATION_SECOND = 31536000; // 1年
const languageKey = 'i18n_redirected';

/**
 * ブラウザの言語設定を取得します。(優先言語が一番上のもの)
 * @return 言語 (例: ja ※ja-jpなどハイフン以降はトリミングしている/en,ja以外は全てenに統一している。)
 */
const getBrowserLanguage = () => {
	let language = (window.navigator.languages && window.navigator.languages[0]) ||
		window.navigator.language ||
		window.navigator.userLanguage ||
		window.navigator.browserLanguage ||
		'en';
	let resultLanguage = language.slice(0, 2);
	if(resultLanguage != "en" && resultLanguage != "ja"){
		resultLanguage = "en";
	}
	return resultLanguage;
}

/**
 * 言語と有効期限をCookieに設定します。
 * @param language 言語
 * @param expirationDate 有効期限
 */
const setCookie = (language, expirationDate=COOKIE_EXPIRATION_SECOND) => {
	document.cookie = `${encodeURIComponent(languageKey)}=${encodeURIComponent(language)};max-age=${expirationDate};Path=/;`;
}

/**
 * Cookieにキーが存在するかチェックします。
 * @param key キー
 * @return true=存在する, false=存在しない
 */
const checkCookie = (key) => {
	if(!key){
		return false;
	}

	let cookie = document.cookie;
	if(!cookie){
		return false;
	}

	let cookieObj = convertCookietoObj(cookie);
	let language = cookieObj[key];
	if(!language){
		return false;
	}
	return true;
}

/**
 * キーからCookie情報を取得します。
 * @param {*} key キー
 * @return Cookie情報 または null
 */
const getCookieInfoByKey = (key) => {
	if(!key){
		return null;
	}

	let cookie = document.cookie;
	if(!cookie){
		return null;
	}

	let cookieArray = convertCookietoObj(cookie);
	return cookieArray[key];
}

/**
 * キーからCookie情報を削除します。
 * @param {*} key キー
 */
const deleteCookie = (key) => {
   document.cookie = `${key};max-age=0;`;
}

/**
 * Cookie情報を連想配列に変換します。
 * @param {*} cookie Cookie
 * @return Cookie情報の連想配列
 */
const convertCookietoObj = (cookie) => {
	let cookiesStr = cookie;
	if(!cookiesStr) {
		return;
	}
	let retAaray = {};
	let cookieArray = cookiesStr.split(';');
	for(let i = 0; i < cookieArray.length; ++i){
		let cookie = cookieArray[i].split('=');
		retAaray[cookie[0].trim()] = decodeURIComponent(cookie[1]);
	}
	return retAaray;
}

module.exports = {
	COOKIE_EXPIRATION_SECOND,
	getBrowserLanguage,
	setCookie,
	checkCookie,
	getCookieInfoByKey,
	deleteCookie,
	convertCookietoObj
}